import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import './styles.scss';

import { IAppState } from 'src/store';

const StatusTag: React.FC<Props> = ({ children, className, variant = 'is-active', ...props }) => {
  return (
    <span className={cn('cmp-status-tag', `cmp-status-tag--${variant}`)} {...props}>
      {children}
    </span>
  );
};

export type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    variant?: 'is-active' | 'is-reject' | 'is-complete' | 'is-pending';
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StatusTag);
